// extracted by mini-css-extract-plugin
export var closeButton = "_di-1";
export var closeX = "_di-3";
export var container = "_di-0";
export var image = "_di-2";